<template>
    <div class="page page-quote">
        <div class="quote-content" :class="{ verified: verified }">
            <div class="quote-content-inner">
                <quote-progress
                    v-if="currentStep && currentStep.includeInCount"
                    :steps="steps"
                    :progress-steps="progressSteps"
                    :step-offset="stepOffsetInCount"
                    :not-in-count="stepOffsetNotInCount"
                    :sub-step="currentSubStep"
                    :step="step"
                    :type="quoteType"
                    :current-step="currentStep"
                />

                <component
                    :is="activeComponent || component"
                    :step="currentStep"
                    :verified="verified"
                    :lead="lead"
                    :constants="currentStep && currentStep.props.constants"
                    @next="next"
                    @prev="prev"
                    @submit="submit"
                    @update_sub_step="updateSubStep"
                    @background="applyBackground"
                    @verificationSent="verificationSent"
                    @verified="isVerified"
                    ref="stepComponent"
                    v-model="form"
                >
                </component>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "../plugins/query-string-object";

import QuoteProgress from "./QuoteSteps/Progress";

export default {
    props: {
        quoteType: {
            type: String,
            default: "car"
        },
        verified: {
            type: Boolean,
            default: false
        }
    },

    components: {
        QuoteProgress
    },

    data() {
        return {
            backgroundImage: null,

            sent: false,

            lead: false,

            steps: window.yna.steps,

            returnToken: window.yna.returnToken,

            step: 0,

            currentSubStep: 0,

            activeComponent: null,

            form: {
                fullName: "",
                idNumber: "",
                code: "",
                phoneNumber: "",
                quoteType: this.quoteType,
                quoteRequestId: window.yna.quoteRequestId,
                terms: false,
                marketing: false
            }
        };
    },

    watch: {
        step() {
            // if (this.step > 0) {
            //     document.querySelector(".quote-prev-link").style.display =
            //         "flex";
            // } else {
            //     document.querySelector(".quote-prev-link").style.display =
            //         "none";
            // }
        }
    },

    mounted() {
        // document.querySelector(".quote-prev-link");
        // .addEventListener("click", e => {
        //     e.preventDefault();
        //     this.quoteStepPrev();
        // });
    },

    created() {
        if (this.verified) {
            this.form = window.yna.form;

            window.addEventListener("hashchange", () => {
                this.hashStepChange();
            });

            this.hashStepChange();
        }
    },

    methods: {
        hashStepChange() {
            let hash = window.location.hash.substring(2);
            let parameters = hash.split("/");
            let query = hash.split("?");
            query = query.pop();
            hash = parameters.shift();

            if (query) {
                query = queryString.parse(query);

                if (query.step) {
                    this.step = parseInt(query.step);

                    if (this.step > this.progressStepsNotExternal.length) {
                        this.step = 0;
                    }
                }
            }
        },

        pushStepState(params = {}) {
            if (!this.verified) {
                return;
            }

            let query = queryString.stringify(params);

            window.history.pushState(null, null, "#?" + query);

            this.hashStepChange();
        },

        async submit() {
            let url = "quote/" + window.yna.quote.request_id;

            if (this.returnToken) {
                url += "?return_token=" + this.returnToken;
            }

            const res = await this.$api.post(url, this.form);

            if (res.hasErrors()) {
                return;
            }

            window.location.href = res.data().redirect;
        },
        updateSubStep(subStep) {
            this.currentSubStep = subStep;

            this.pushStepState({
                step: this.step,
                subStep: subStep
            });
        },
        applyBackground(subStep) {
            this.backgroundImage = this.currentStep.background[subStep];
        },

        verificationSent(lead) {
            this.sent = true;
            this.lead = lead;
        },

        isVerified(nextUrl) {
            window.location.href = nextUrl;
        },

        next() {
            if (this.isNotFinalStep) {
                this.step += 1;

                this.pushStepState({
                    step: this.step
                    // subStep: 0
                });

                return;
            }

            console.log("Final step...");
        },

        prev() {
            if (this.isNotFirstStep) {
                this.step = this.step - 1;

                this.$nextTick(() => {
                    this.$refs.stepComponent.$emit("set_prev_substep");
                });

                // temporary
                // temporary
                // temporary
                // todo
                // todo
                // if (this.quoteType === 'car'
                //     && this.currentStep.component === 'CarQuotePassedInsurance'
                //     && ! this.form[this.currentStep.component].claims) {
                //     this.$nextTick(() => {
                //         this.$refs.stepComponent.$emit('set_prev_substep', 1);
                //     });
                // } else if (this.quoteType === 'car'
                //     && this.currentStep.component === 'CarQuotePassedInsurance'
                //     && this.form[this.currentStep.component].claims
                //     && this.form[this.currentStep.component].claims) {
                //     this.$nextTick(() => {
                //         this.$refs.stepComponent.$emit('set_prev_substep', 4);
                //     });
                // } else {
                //     this.$nextTick(() => {
                //         this.$refs.stepComponent.$emit('set_prev_substep');
                //     });
                // }
            }
        },

        quoteStepPrev() {
            this.$refs.stepComponent.prev();
        }
    },

    computed: {
        progressSteps() {
            return this.steps.filter(step => step.includeInCount === true);
        },
        progressStepsNotExternal() {
            return this.steps.filter(step => step.external !== true);
        },
        stepOffsetInCount() {
            return this.steps.length - this.progressSteps.length;
        },
        stepOffsetNotInCount() {
            return this.steps.filter(step => !step.includeInCount).length;
        },
        background() {
            let backgroundImage = this.backgroundImage;

            if (!this.verified) {
                backgroundImage = this.sent ? "verification" : "welcome";
            }

            if (!backgroundImage) {
                return {};
            }

            return {
                backgroundImage: `url(/images/backgrounds/${backgroundImage}.jpg)`
            };
        },

        isNotFinalStep() {
            // return false;
            return this.step < this.steps.length - 1;
        },

        isNotFirstStep() {
            return this.step > 0;
        },

        currentStep() {
            if (!this.verified) {
                return null;
            }

            return this.steps[this.step];
        },

        component() {
            if (!this.verified) {
                return this.sent ? "QuoteVerification" : "QuoteWelcome";
            }

            return this.currentStep.component;
        }
    }
};
</script>

<style lang="scss" scoped>
//.quote-content-inner {
//    display: flex;
//    flex-direction: column;
//    justify-content: center;
//    align-items: center;
//}
.quote-step {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    ::v-deep {
        .form-error-message {
            padding: 10px 20px;
            border-radius: 100px;
            background-color: $error-red;
            color: white;
            margin-bottom: 25px;
        }
    }
}
</style>
